import { spring } from './spring';

export const transition = {
  default: {
    default: {
      type: 'spring',
      ...spring.default
    }
  },
  disabled: {
    default: {
      duration: 0
    }
  }
} as const;
